import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon", "button"]

  declare readonly menuTarget: HTMLElement
  declare readonly openIconTarget: HTMLElement
  declare readonly closeIconTarget: HTMLElement
  declare readonly buttonTarget: HTMLElement

  private isOpen = false

  toggle() {
    this.isOpen = !this.isOpen
    this.updateMenu()
  }

  close() {
    this.isOpen = false
    this.updateMenu()
  }

  private updateMenu() {
    if (this.isOpen) {
      this.menuTarget.classList.remove("hidden")
      this.openIconTarget.classList.add("hidden")
      this.closeIconTarget.classList.remove("hidden")
    } else {
      this.menuTarget.classList.add("hidden")
      this.openIconTarget.classList.remove("hidden")
      this.closeIconTarget.classList.add("hidden")
    }
  }
}
